// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentSummaryItem_root_hOkSy","title":"PaymentSummaryItem_title_BKMrk","text":"PaymentSummaryItem_text_1Tcpy"};